export default __webpack_public_path__ + "media/images/user_photos/162-ce507aa137dee1de72c14c2d6a537cfd.jpg";